/** Teams presence */
export enum PresenceStatus {
  Available = 'Available',
  Away = 'Away',
  BeRightBack = 'BeRightBack',
  Busy = 'Busy',
  DoNotDisturb = 'DoNotDisturb',
  InACall = 'InACall',
  InAConferenceCall = 'InAConferenceCall',
  Inactive = 'Inactive',
  InAMeeting = 'InAMeeting',
  Offline = 'Offline',
  OffWork = 'OffWork',
  OutOfOffice = 'OutOfOffice',
  PresenceUnknown = 'PresenceUnknown',
  Presenting = 'Presenting',
  UrgentInterruptionsOnly = 'UrgentInterruptionsOnly'
}

/** Teams presence with bonuses */
export interface HejPresence {
  id?: string;
  color: string;
  title: string;
  status: PresenceStatus;
  outOfOfficeMessage: string;
}
